import CityPageTemplate from "../city-template/CityPageTemplate";
import { grandRapidsConfig } from "./data";

export default function GrandRapidsPage() {
  return <CityPageTemplate config={grandRapidsConfig} />;
}